import React, {useEffect, useState} from 'react';
import {Dropdown, Menu, MenuProps} from 'antd';
import './navigation-menu.scss';
import {useLocation, useNavigate} from 'react-router';
import useDeviceFeature from '@/hooks/use-device-feature';
import {MenuOutlined} from '@ant-design/icons';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[], type?: 'group'): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}

const items: MenuProps['items'] = [
    getItem('首页', 'home'),
    getItem('购买', 'report/recent'),
    getItem('信息', 'info'),
    getItem('推荐', 'recommend'),
    getItem('交易', 'hold'),
    getItem('资金', 'fund'),
];

const NavigationMenu = () => {
    const navigate = useNavigate();
    const {pathname = ''} = useLocation();
    const [selectedKey, setSelectedKey] = useState(['home']);
    const {isPhone} = useDeviceFeature();

    useEffect(() => {
        let key: string | undefined;
        if (pathname === '/') {
            key = 'home';
        } else if (pathname.startsWith('/info')) {
            key = 'info';
        } else if (pathname.startsWith('/recommend')) {
            key = 'recommend';
        } else if (pathname.startsWith('/hold')) {
            key = 'hold';
        } else if (pathname.startsWith('/fund')) {
            key = 'fund';
        } else if (pathname.startsWith('/report/recent')) {
            key = 'report/recent';
        }
        if (key) {
            setSelectedKey([key]);
        }
    }, [pathname]);

    const onClickMenu = (item: any) => {
        const to = item.key === 'home' ? '/' : item.key;
        navigate(to, {replace: true});
        setSelectedKey([item.key]);
    };

    const renderMenu = () => (
        <div className="navigation-menu-content">
            <Menu
                className="drop-shadow-lg"
                style={{width: 180, height: '100%'}}
                selectedKeys={selectedKey}
                mode="inline"
                items={items}
                onClick={onClickMenu}
            />
        </div>
    );

    return isPhone ? (
        <div className="pb-16">
            <div className="fixed pl-4 pt-4 z-10">
                <Dropdown overlay={renderMenu()} arrow placement="topRight">
                    <MenuOutlined className="p-4 rounded-full bg-gray-200 opacity-80 border-2" />
                </Dropdown>
            </div>
        </div>
    ) : (
        <div>{renderMenu()}</div>
    );
};

export default NavigationMenu;
